import { observer } from 'mobx-react'
import cx from 'classnames'
import CanvasGlow from '@/ui/CanvasGlow'

interface ChatHaloProps {
  isVisible?: boolean
}

const ChatHalo = ({ isVisible }: ChatHaloProps) => {
  return (
    <div className={cx('chatHalo', { 'is-visible': isVisible })}>
      {isVisible && <CanvasGlow glowType="ChatVoice" inset />}
    </div>
  )
}

export default observer(ChatHalo)
